import * as React from 'react';
import IDHelpers from '@/core/helpers/IDHelper';
import TextHelper from '@/core/helpers/TextHelper';
import { Container } from './styes';

interface ResumeDetailProps {
  title?: string;
  data: any;
  labels: string[];
  fields: string[];
  showBullets?: boolean;
  fontWeight?: string;
  color?: string;
}
const ResumeDetail = ({
  title,
  data,
  labels,
  fields,
  showBullets = false,
  fontWeight,
  color = '#161D1F'
}: ResumeDetailProps) => (
  <Container>
    {title && <>{title}</>}
    <ul style={{ marginLeft: showBullets ? 14 : 0, color }}>
      {fields.map((f, i) =>
        data[f] ? (
          <li
            style={showBullets ? { listStyle: 'initial' } : {}}
            key={IDHelpers.generateID()}
          >
            {labels[i]}:{' '}
            <span style={{ fontWeight, color }}>
              {TextHelper.capitalize(data[f], false, true)}
            </span>
          </li>
        ) : null
      )}
    </ul>
  </Container>
);

export default ResumeDetail;
